import { equals, groupWith } from 'ramda'
import { ConversationEventType } from 'shared/typings/messages/conversationevents/ConversationEventType'
import { Message } from 'shared/typings/messages/Message'
import { MessageType } from 'shared/typings/messages/MessageType'
import spacetime from 'spacetime'

const MESSAGE_GROUP_TIME_SEPARATOR_IN_SECONDS = 60

export enum MessageSendStatus {
  SUCCESS,
  PENDING,
  FAIL,
}

export const getMessageSendStatus = (message: Message): MessageSendStatus => {
  switch (message.id) {
    case undefined:
      return MessageSendStatus.PENDING
    case -1:
      return MessageSendStatus.FAIL
    default:
      return MessageSendStatus.SUCCESS
  }
}

const isGroupedType = (a: Message) => [MessageType.CHAT, MessageType.PRIVATE_NOTE].includes(a.type)

export const groupByDayAndProximity = (messages: Message[]) =>
  groupWith(
    (a: Message, b: Message) => spacetime(b.createdAt).isSame(spacetime(a.createdAt), 'day'),
    messages
  ).map((messagesByDay) =>
    groupWith(
      (a: Message, b: Message) =>
        equals(a.authorType, b.authorType) &&
        equals(a.authorId, b.authorId) &&
        a.type === b.type &&
        isGroupedType(a) &&
        isGroupedType(b) &&
        spacetime(b.createdAt).isBefore(
          spacetime(a.createdAt).add(MESSAGE_GROUP_TIME_SEPARATOR_IN_SECONDS, 'second')
        ),
      messagesByDay
    )
  )

export const endUserMessageCondition = (message: Message) =>
  message.authorType === 'LEAD' && message.type === MessageType.CHAT

export const agentMessageCondition = (message: Message) =>
  message.authorType === 'USER' && message.type === MessageType.CHAT && !message.attributes?.isBot

export const botMessageCondition = (message: Message) =>
  message.authorType === 'USER' && message.type === MessageType.CHAT && message.attributes?.isBot

export const joinEventCondition = (message: Message) =>
  message.type === MessageType.CONVERSATION_EVENT &&
  message.conversationEvent?.type === ConversationEventType.ADDED_PARTICIPANTS &&
  message.conversationEvent?.currentParticipantIds?.length === 1
